module.exports = __webpack_public_path__ + "img/cash-in_isotipo_fondoazul.8935e3b2.webp";